<template>
  <BaseCardV2
    :btn-action="loading.repartitionAdherent || hasCarteRemplie ? null : {
      libelle: 'Voir mon taux',
      icon: !isAbonneCulturial ? 'mdi-lock' : '',
      hasOtherAtion: true
    }"
    :has-btn-action="!loading.repartitionAdherent && !hasCarteRemplie"
    :has-help="hasCarteRemplie"
    :titre="'Répartition du chiffre d\'affaires'"
    class="pa-2"
    @otherAction="onClickInformationAbonnement()"
    @on-help="isOpenModalHelp = true"
  >
    <div
      class="mb-2"
    >
      <BaseLoader v-if="loading.repartitionAdherent" />

      <BaseMessageServerError
        v-else-if="erreur.repartitionAdherent"
        class="mx-5 my-2"
      />
      <div v-else-if="!hasCarteRemplie">
        <div
          class="d-flex align-center flex-column"
          :class="$vuetify.breakpoint.mobile ? 'mt-6' : 'mt-16'"
        >
          <img
            src="@/assets/no-commercialisation.svg"
            alt="no-commercialisation"
          >
          <div
            class="intro texte-gris-fonce text-align-center mt-2"
            :class="$vuetify.breakpoint.mobile ? 'mb-6' : 'mx-16'"
          >
            <span>Gardez un œil sur la part de votre atelier cultures dans votre chiffre d’affaires total</span>
          </div>
        </div>
      </div>

      <template v-else>
        <v-row
          class="mt-2 ml-2"
          no-gutters
        >
          <v-col
            cols="12"
            md="6"
          >
            <v-icon
              class="mr-1 positif-color"
              size="14"
            >
              mdi-circle
            </v-icon>
            <span class="texte texte-gris-fonce">
              Mon atelier cultures de vente
            </span>
          </v-col>
          <v-col
            cols="12"
            md="5"
          >
            <v-icon
              size="14"
              color="grey lighten-2"
              class="mr-1"
            >
              mdi-circle
            </v-icon>
            <span class="texte texte-gris-fonce">
              Autres ateliers
            </span>
          </v-col>
        </v-row>

        <div
          class="d-flex"
          :class="$vuetify.breakpoint.mobile ? 'position-percent-mobile' : 'position-percent'"
        >
          <div class="chiffre-xxl align-self-center positif-color">
            {{ pourcentageAtelierCulture | roundNumber(0) }}
          </div>
          <div class="titre-h1 align-self-center ml-1 positif-color">
            %
          </div>
        </div>

        <v-row
          no-gutters
          justify="center"
          class="mt-6"
        >
          <v-col
            cols="12"
            class="mt-3"
            align="center"
          >
            <PercentageDoughnut
              :data="{
                percentage: pourcentageAtelierCulture >= 100 ? 99.99 : pourcentageAtelierCulture,
                value: chiffreAffairesAtelierCultureEnEuro,
                unit: '€',
                precision: 0,
                label: 'Chiffre d\'affaires cultures',
                others: {
                  value: chiffreAffairesAutresAteliersEnEuro,
                  label: 'Chiffre d\'affaires autres ateliers'
                }
              }"
              :size="$vuetify.breakpoint.mobile ? 160 : 200"
              width="30"
              positive-color="#dbbd00"
              negative-color="#ec6608"
            >
              <img
                alt="picto-piece"
                class="picto-piece"
                src="@/assets/picto-piece.svg"
              >
            </PercentageDoughnut>
          </v-col>
        </v-row>

        <div class="bottom">
          <v-divider class="my-6 mx-3" />
          <div class="d-flex justify-space-between mx-3">
            <div class="d-flex flex-column">
              <div class="titre-h4 texte-gris-fonce mb-2">
                Total CA comptable
              </div>
              <div class="d-flex">
                <span class="titre-h3 secondary--text align-self-center mr-2">{{ chiffreAffairesExploitationEnEuro | roundNumber(0) | splitNumber }} €</span>
                <BaseEvolutionWithInfo
                  v-if="evolutionChiffreAffairesEnPourcentage != null"
                  :evolution-value="evolutionChiffreAffairesEnPourcentage"
                  :values="chiffreAffairesParAnnee"
                  :unite="'€'"
                />
              </div>
            </div>
            <div class="ml-auto">
              <UserIndicatorJauge
                v-if="repartitionChiffreAffairesGroupe != null || loading.repartitionGroupe"
                :chargement="loading.repartitionGroupe"
                :data="{
                  value: positionJaugeGroupe(repartitionChiffreAffairesGroupe?.codePositionDuNumtiers)
                }"
                :unite="'%'"
                :is-parametres-exploitation-incomplet="!isParametresExploitationComplet"
                :data-groupe="repartitionChiffreAffairesGroupe?.valeurMoyenneDuGroupe"
                :negative-color="repartitionChiffreAffairesGroupe?.valeurMoyenneDuGroupe && isParametresExploitationComplet ? '#ec6608' : 'grey'"
                :positive-color="repartitionChiffreAffairesGroupe?.valeurMoyenneDuGroupe && isParametresExploitationComplet ? '#01713c' : 'grey'"
              />
            </div>
          </div>
        </div>
      </template>

      <HelpModal
        v-if="isOpenModalHelp"
        titre="Répartition du chiffre d'affaires"
        :is-open-modal-help="isOpenModalHelp"
        @close="isOpenModalHelp = false"
      >
        <div slot="baseCardHelpContent">
          <div class="texte text-justify texte-gris-fonce pa-8">
            <p>Les données indiquées correspondent aux chiffres d'affaires de votre clôture comptable.</p>
            <p class="pt-2">
              En cas de changement majeur sur votre exploitation, ces données ont pu être actualisées par votre conseiller DTE à la suite d'échanges que vous avez eus ensemble.
            </p>
            <p class="pt-2">
              Comparez vos données aux années précédentes lorsqu'elles sont disponibles et à un groupe de comparaison (au niveau du compteur).
            </p>
            <p class="pt-2">
              Sur ce compteur, le quart supérieur du groupe est matérialisé en vert, le quart inférieur est lui, en orange. Quant aux valeurs intermédiaires (entre 25 et 75% des valeurs du groupe), elles sont affichées en gris.
            </p>
          </div>
        </div>
      </HelpModal>

      <InformationAbonnementModal
        v-if="isOpenModalAideInformationAbonnement"
        :is-open-modal-information-abonnement="isOpenModalAideInformationAbonnement"
        code-feature="BILAN_ANNUEL"
        texte="Soyez accompagné par un expert pour faire le bilan de vos coûts et résultats de vos grandes cultures."
        titre="Bilan annuel de vos cultures"
        :is-conseiller-pv-affiche="!isAbonneCulturial"
        @close="isOpenModalAideInformationAbonnement = false"
      />
    </div>
  </BaseCardV2>
</template>

<script>
import BaseCardV2 from '@/components/card/base-card-v2.vue'
import BaseEvolutionWithInfo from '@/components/common/base-evolution-with-info.vue'
import BaseMessageServerError from '@/components/common/base-message-server-error.vue'
import PercentageDoughnut from '@/components/chart/v2/percentage-doughnut.vue'
import UserIndicatorJauge from '@/components/chart/v2/user-indicator-jauge.vue'
import HelpModal from '@/components/modal/help-modal.vue'
import {mapActions, mapGetters} from 'vuex'
import BaseLoader from '@/components/common/base-loader.vue'
import InformationAbonnementModal from '@/views/offre-abonnement/components/modal/information-abonnement-modal.vue'
import { isPanneServeur } from '@/utils/requete'

export default {
  name: 'RepartitionChiffreAffaires',
  components: {
    BaseCardV2, BaseEvolutionWithInfo, BaseLoader, BaseMessageServerError,
    HelpModal, InformationAbonnementModal, PercentageDoughnut, UserIndicatorJauge
  },
  props: {
    codeGraineRs3Selected: {
      type: String,
      default: null
    },
    anneeRecolteSelected: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      isOpenModalHelp: false,
      isOpenModalAideInformationAbonnement: false,
      loading: {
        repartitionAdherent: false,
        repartitionGroupe: false
      },
      erreur: {
        repartitionAdherent: false
      }
    }
  },

  computed: {
    ...mapGetters({
      abonnements: 'adherent/abonnements',
      filtresAdherent: 'filtresComparaison/filtresAdherent',
      atelierCultureVerrouillage: 'cloture/atelierCultureVerrouillage',
      repartitionChiffreAffaires: 'cloture/repartitionChiffreAffaires',
      repartitionChiffreAffairesGroupe: 'cloture/repartitionChiffreAffairesGroupe',
      isParametresExploitationComplet: 'parametresExploitation/isParametresExploitationComplet'
    }),
    isAbonneCulturial () {
      return this.abonnements.culturialAbonne
    },
    hasClotureVerrouillee () {
      return this.atelierCultureVerrouillage != null && this.atelierCultureVerrouillage.isAtelierVerrouille
    },
    pourcentageAtelierCulture () {
      return this.repartitionChiffreAffaires != null ? this.repartitionChiffreAffaires.pourcentageChiffreAffairesAtelierCulture : null
    },
    chiffreAffairesAtelierCultureEnEuro () {
      return this.repartitionChiffreAffaires != null ? this.repartitionChiffreAffaires.chiffreAffairesAtelierCultureEnEuro : null
    },
    chiffreAffairesAutresAteliersEnEuro () {
      return this.repartitionChiffreAffaires != null ? this.repartitionChiffreAffaires.chiffreAffairesAutresAteliersEnEuro : null
    },
    chiffreAffairesExploitationEnEuro () {
      return this.repartitionChiffreAffaires != null ? this.repartitionChiffreAffaires.chiffreAffairesExploitationEnEuro : null
    },
    evolutionChiffreAffairesEnPourcentage () {
      return this.repartitionChiffreAffaires != null ? this.repartitionChiffreAffaires.evolutionChiffreAffairesExploitationEnPourcentage : null
    },
    chiffreAffairesParAnnee () {
      return this.repartitionChiffreAffaires != null ? this.repartitionChiffreAffaires.chiffreAffairesExploitationParAnnee : null
    },
    hasCarteRemplie () {
      return this.isAbonneCulturial
        && this.hasClotureVerrouillee
        && this.pourcentageAtelierCulture != null
    }
  },

  watch: {
    anneeRecolteSelected () {
      this.loadRepartitionAdherent()
    },
    hasClotureVerrouillee () {
      this.loadRepartitionAdherent()
    },
    isAbonneCulturial () {
      this.loadRepartitionAdherent()
    },
    filtresAdherent () {
      this.loadRepartitionGroupe()
    }
  },

  created () {
    this.loadRepartitionAdherent()
  },
  methods: {
    ...mapActions({
      incrementerAccesSouscriptionAbonnement: 'accesSouscriptionAbonnement/incrementerAccesSouscriptionAbonnement',
      getRepartitionChiffreAffaires: 'cloture/getRepartitionChiffreAffaires',
      getRepartitionChiffreAffairesGroupe: 'cloture/getRepartitionChiffreAffairesGroupe'
    }),
    loadRepartitionAdherent () {
      if (!this.isAbonneCulturial || !this.hasClotureVerrouillee) {
        return
      }

      this.loading.repartitionAdherent = true
      this.erreur.repartitionAdherent = false
      this.getRepartitionChiffreAffaires()
        .then(() => this.loadRepartitionGroupe())
        .catch((erreur) => {
          this.erreur.repartitionAdherent = isPanneServeur(erreur)
        })
        .finally(() => {
          this.loading.repartitionAdherent = false
        })
    },
    loadRepartitionGroupe () {
      if (!this.hasCarteRemplie) {
        return
      }

      this.loading.repartitionGroupe = true
      this.getRepartitionChiffreAffairesGroupe()
        .catch(() => {})
        .finally(() => {
          this.loading.repartitionGroupe = false
        })
    },
    positionJaugeGroupe (codePosition) {
      let result = null
      switch (codePosition) {
        case 'QUARTILE_SUP':
          result = 'positive'
          break
        case 'QUARTILE_INF':
          result = 'negative'
          break
        case 'MOYENNE':
          result = 'center'
          break
      }
      return result
    },
    onClickInformationAbonnement () {
      this.isOpenModalAideInformationAbonnement = true
      this.incrementerAccesSouscriptionAbonnement('BILAN_ANNUEL')
    }
  }
}

</script>

<style lang="scss" scoped>
.picto-piece {
  width: 32%;
}
.positif-color {
  color: #dbbd00;
}
.negatif-color {
  color: #ec6608;
}
.position-percent-mobile {
  position: absolute;
  right: 28px;
  top: 110px;
}
.position-percent {
  position: absolute;
  right: 58px;
  top: 110px;
}
</style>
